<template>
  <div>
    <el-container>
      <el-header :style="{ display: isHeaderShow ? 'block' : 'none' }">
        <NavHeader></NavHeader>
      </el-header>

      <el-container>
        <el-aside width="200px" :style="{ display: isAsideShow ? 'block' : 'none' }">
          <NavAside></NavAside>
        </el-aside>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'APP',
  computed: {
    ...mapState('m_tabs', ['isAsideShow', 'isHeaderShow'])
  }
}
</script>

<style lang="scss">


#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

* {
  margin: 0;
  padding: 0;
  /* 內减模式 */
  box-sizing: border-box;
  font-size: 14px;
}

/* 去掉菜单样式 */
li {
  list-style: none;
}

/* 去掉a标签的下划线 */
a {
  text-decoration: none;
}

body {
  background-color: #f5f7fa;
}

// elementui 定制

.el-header,
.el-aside {
  background-color: #fff;
}
</style>
